import React, { useState } from 'react'
import { Drawer, Button, Tag, Icon, Input, Tooltip } from 'antd';
import { useUpdateEffect } from 'ahooks';
import './index.less';

export default (props) => {
  const { editTagsDrawer, onClose, supplementWordList, attrWordList, classifyWord, setAttrWordList, setSupplementWordList, setClassifyWord, goUpdateInsImgTag, insId } = props
  // 新增
  const [classifyWordInputVisible, setClassifyWordInputVisible] = useState(false)
  const [attrWordListInputVisible, setAttrWordListInputVisible] = useState(false)
  const [supplementWordListInputVisible, setSupplementWordListInputVisible] = useState(false)
  // 新输入属性tag
  const [inputAttrValue, setinputAttrValue] = useState('')
  // 新输入标签tag
  const [inputSuppValue, setinputSuppValue] = useState('')
  // 新输入分类tag
  const [inputClassifyValue, setinputClassifyValue] = useState('')

  useUpdateEffect(() => {
    if (!editTagsDrawer) {
      setinputAttrValue('')
      setinputSuppValue('')
      setinputClassifyValue('')
    }
  }, [editTagsDrawer])
  // 分类tag
  const handleClassifyInputChange = (e) => {
    setinputClassifyValue(e.target.value)
  }
  const handleClassifyInputConfirm = () => {
    if (inputClassifyValue) {
      setClassifyWord(inputClassifyValue)
      setinputClassifyValue('')
      setClassifyWordInputVisible(false)
    }
  }
  const handleClassifyClose = () => {
    setClassifyWord('')
  }
  // 属性tag
  const handleAttrInputChange = (e) => {
    setinputAttrValue(e.target.value)
  }
  const handleAttrInputConfirm = () => {
    if (inputAttrValue && attrWordList.indexOf(inputAttrValue) === -1) {
      setAttrWordList([...attrWordList, inputAttrValue])
      setinputAttrValue('')
      setAttrWordListInputVisible(false)
    }
  }
  const handleAttrClose = (removeTag) => {
    const newTagList = attrWordList.filter((tag) => tag !== removeTag)
    setAttrWordList([...newTagList])
  }
  // 标签tag
  const handleSuppInputChange = (e) => {
    setinputSuppValue(e.target.value)
  }
  const handleSuppInputConfirm = () => {
    if (inputSuppValue && supplementWordList.indexOf(inputSuppValue) === -1) {
      setSupplementWordList([...supplementWordList, inputSuppValue])
      setinputSuppValue('')
      setSupplementWordListInputVisible(false)
    }
  }
  const handleSuppClose = (removeTag) => {
    const newTagList = supplementWordList.filter((tag) => tag !== removeTag)
    setSupplementWordList([...newTagList])
  }
  return (
    <>
      <Drawer title="编辑图片标签" placement="right" onClose={onClose} visible={editTagsDrawer} mask={false} width={320}>
        <p><span style={{ width: 70 }}>分类标签：</span>
          {
            classifyWord ?
              <Tag key={classifyWord} closable onClose={handleClassifyClose}>{classifyWord}</Tag> : null
          }
          {classifyWordInputVisible && (
            <Input
              type="text"
              size="small"
              style={{ width: 78 }}
              value={inputClassifyValue}
              onChange={handleClassifyInputChange}
              onBlur={handleClassifyInputConfirm}
              onPressEnter={handleClassifyInputConfirm}
            />
          )}
          {!classifyWordInputVisible && !classifyWord && (
            <>
              <Tag onClick={() => setClassifyWordInputVisible(true)} style={{ background: '#fff', borderStyle: 'dashed' }}>
                <Icon type="plus" />添加分类
              </Tag>
            </>
          )}
        </p>
        <p style={{ display: 'flex' }}><span style={{ width: 70 }}>属性标签：</span>
          <div style={{ flex: 1 }}>
            {attrWordList?.map((tag) => {
              const isLongTag = tag.length > 20;
              const tagElem = (
                <Tag key={tag} closable onClose={() => handleAttrClose(tag)} style={{ marginBottom: 10 }}>
                  {isLongTag ? `${tag.slice(0, 20)}...` : tag}
                </Tag>
              );
              return isLongTag ? (
                <Tooltip title={tag} key={tag}>
                  {tagElem}
                </Tooltip>
              ) : (
                tagElem
              );
            })}
            {attrWordListInputVisible && (
              <Input
                type="text"
                size="small"
                style={{ width: 78 }}
                value={inputAttrValue}
                onChange={handleAttrInputChange}
                onBlur={handleAttrInputConfirm}
                onPressEnter={handleAttrInputConfirm}
              />
            )}
            {!attrWordListInputVisible && (
              <Tag onClick={() => setAttrWordListInputVisible(true)} style={{ background: '#fff', borderStyle: 'dashed' }}>
                <Icon type="plus" />添加属性
              </Tag>
            )}
          </div>
        </p>
        <p style={{ display: 'flex' }}><span style={{ width: 70 }}>补充标签：</span>
          <div style={{ flex: 1 }}>
            {supplementWordList?.map((tag) => {
              const isLongTag = tag.length > 20;
              const tagElem = (
                <Tag key={tag} closable onClose={() => handleSuppClose(tag)} style={{ marginBottom: 10 }}>
                  {isLongTag ? `${tag.slice(0, 20)}...` : tag}
                </Tag>
              );
              return isLongTag ? (
                <Tooltip title={tag} key={tag}>
                  {tagElem}
                </Tooltip>
              ) : (
                tagElem
              );
            })}
            {supplementWordListInputVisible && (
              <Input
                type="text"
                size="small"
                style={{ width: 78 }}
                value={inputSuppValue}
                onChange={handleSuppInputChange}
                onBlur={handleSuppInputConfirm}
                onPressEnter={handleSuppInputConfirm}
              />
            )}
            {!supplementWordListInputVisible && (
              <Tag onClick={() => setSupplementWordListInputVisible(true)} style={{ background: '#fff', borderStyle: 'dashed' }}>
                <Icon type="plus" />添加标签
              </Tag>
            )}
          </div>
        </p>
        <div className='two_button'> <Button onClick={onClose}>取消</Button> <Button type="primary" onClick={() => goUpdateInsImgTag({ insId, supplementWordList, attrWordList, classifyWord })} disabled={!attrWordList || supplementWordList.length == 0 || attrWordList.length == 0}>确定</Button> </div>
      </Drawer>
    </>
  )
}
